const API_BASE = "https://exam-portal-api.vercel.app/api";

export default API_BASE;